import { icon_file_extension } from 'components/base/images';
import convertToPartType from 'lib/library';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

interface ProjectFileIconProps {
  fileName: string;
  projectId: string;
}
function ProjectFileIcon({ fileName, projectId }: ProjectFileIconProps) {
  const extension = convertToPartType(fileName, projectId);

  return (
    <StyledProjectFileIcon data-component-name="ProjectFileIcon" $iconImage={icon_file_extension}>
      <span className="projectFileIcon__extension">{extension}</span>
    </StyledProjectFileIcon>
  );
}

const StyledProjectFileIcon = styled.div<{ $iconImage: string }>`
  background-image: ${({ $iconImage }) => `url(${$iconImage})`};
  width: 54px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  .projectFileIcon__extension {
    font-size: 10px;
    color: #00a6e2;
    word-break: normal;
    white-space: pre-wrap;
    word-spacing: normal;
    text-align: center;
  }
`;

export default React.memo(ProjectFileIcon);
